import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { ROLE_PATH, LAYOUT_PATH } from "../../routing/paths";
import SimpleStep from "../SimpleStep";
import { numericNormalizer } from "../../shared/normalizers";

const simpleStepProps = {
  previous: ROLE_PATH,
  next: LAYOUT_PATH,
  question: "What's your",
  target: "cell phone number",
  description: "We promise not to send spam or be annoying.",
  placeholder: "5128675309",
  spellName: "phone",
  required: false,
  normalizer: numericNormalizer
};

export const ContactPhoneStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <SimpleStep wizard={props} {...simpleStepProps} />
);

export default WizardContainer(ContactPhoneStep);
